<!--<ng-container *ngIf="isUrl() || isMail()">-->
<!--  <a [href]="urlText()" target="_blank">{{message.body}}</a>-->
<!--  <span [innerHtml]="urlText()"></span>-->
<!--</ng-container>-->
<!--<ng-container *ngIf="isPlain()">-->
  <h5 class="text" [innerHtml]="message.url_body"></h5>
<!--</ng-container>-->
